module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-08-24 at 14.51.57.a8d60d34.png";